import type ISaasOverviewRepository from '../ISaasOverviewRepository';
import type { SaasOverview } from '../Types';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';

/**
 * MZP2-6063: SaaSOps 대시보드 카드용 집계 API.
 * GET /api/v1/statistics/product-subscription-overview
 */
@injectable()
export class SaasOverviewRepository implements ISaasOverviewRepository {
  async getOne(utilizationThreshold?: number): Promise<SaasOverview> {
    const queryString = qs.stringify(
      utilizationThreshold !== undefined ? { utilizationThreshold } : {},
      { addQueryPrefix: true },
    );
    const result = await API.get<SaasOverview>(
      `/api/v1/statistics/product-subscription-overview${queryString}`,
    );
    return result.data;
  }
}
